/**
 * Small pure helpers for PickerNavigator — inlined here (rather than importing
 * the workspace copies) so the shared drive-browser lives in @papan/files with
 * no dependency back on @papan/workspace. Mirrors workspace/ui/driveRoot +
 * fileFilter; keep them in sync if the sort/root rules change.
 */
import { isProjectFolder } from '@papan/types'

/** Build the deterministic root folder ID for a tenant. */
export function getRootFolderId(tenantId: string): string {
  return `papan_${tenantId}`
}

/** Check whether a folder ID is a papan root folder. */
export function isRootFolderId(id: string): boolean {
  return id.startsWith('papan_')
}

/** Sort priority: folders first (excluding project folders), then project folders, then files. */
function fileSortKey(item: { name: string; isFolder: boolean }): number {
  if (isProjectFolder(item.name)) return 1
  if (item.isFolder) return 0
  return 2
}

/** Sort file items: folders > project folders > files. Stable within groups. */
export function sortFileItems<T extends { name: string; isFolder: boolean }>(items: T[]): T[] {
  return [...items].sort((a, b) => fileSortKey(a) - fileSortKey(b))
}
